<!-- @if (hasSliderFilters) {
<p-card class="border-round-2xl w-full bg-white mb-4 card">
    <p-panel #panel [toggleable]="true" [collapsed]="true" show="false" class="w-full border-none shadow-none">
        <ng-template #header>
            <div class="flex align-items-center gap-2">
                <span class="panel-title">Filter</span>
            </div>
        </ng-template>

        <ng-template #icons>

            @if (showClearFilters) {
            <p-button text="true" [disabled]="!hasActiveFilters" (onClick)="clearAllFilters()" pTooltip="Clear filters" tooltipPosition="top" tooltipStyleClass="tooltip">
                <ng-template #icon>
                    <img src="assets/icons/circular-counterclockwise-arrow-rotation_60585 1.svg" alt="clear" class="panel-icon" />
                </ng-template>
            </p-button>
            }

        </ng-template>
        <ng-template #headericons>
            <p-button text="true" (onClick)="panel.toggle($event)">
                <ng-template #icon>
                    <img src="assets/icons/funnel-fill.svg" alt="filter" class="panel-icon" />
                </ng-template>
            </p-button>
        </ng-template>

        <div class="filters flex gap-6 mb-3 flex-wrap">
            @for (col of columns; track $index) {
            @if (col.isFilterable && col.filterType === 'slider') {
            <div class="flex flex-wrap flex-column w-15rem">
                <span class="font-semibold text-base line-height-3 mb-4">{{ col.header }}</span>

                @if (col.filterType === 'slider') {
                @if (col.isFilterable && col.filterType === 'slider') {
                <p-slider [min]="col.min" [max]="col.max" [step]="col.step" [formControl]="filterControls[col.field]" [range]="true" (onSlideEnd)="emitFilters()"></p-slider>
                @if (filterControls[col.field].value) {
                <div class="flex justify-content-center text-sm text-600 mt-2">
                    <span>{{ filterControls[col.field].value }}</span>
                </div>
                }
                <div class="flex justify-content-between text-sm text-600 mt-2">
                    <span>{{ col.min}}</span>
                    <span>{{ col.max }}</span>
                </div>
                }
                }
            </div>
            }
            }
        </div>
    </p-panel>
</p-card>
} -->


<div class="table-header" [class.table-header--borderless]="!showHeaderBorder">

    @if (tableName || showColumnSelector) {
    <!-- ── Standard layout: title + column selector on left, search + filters on right ── -->
    <div class="flex flex-wrap justify-content-between align-items-center gap-3">
        <div class="flex flex-row flex-wrap gap-2 align-items-center">
            @if (tableName) {
            <h2 class="table-title m-0">{{ tableName }}</h2>
            }
            @if (showColumnSelector) {
            <p-multiSelect class="multi-select" [options]="columns" [(ngModel)]="visibleColumns" optionLabel="header"
                display="chip" placeholder="Select Columns"
                [selectedItemsLabel]="visibleColumns.length > 2 ? visibleColumns.length + ' Columns Selected' : undefined">
            </p-multiSelect>
            }
        </div>
        <div class="flex align-items-center gap-2 flex-wrap">
            @if (showSearch) {
            <p-iconfield class="w-10rem">
                <p-inputicon><img src="assets/icons/search.svg" alt="search icon" /></p-inputicon>
                <input type="text" pInputText [placeholder]="searchPlaceholder || 'Search'" class="w-full search-bar"
                    [formControl]="searchControl" />
                @if (searchControl.value) {
                <p-inputicon class="fa-solid fa-xmark cursor-pointer text-500" (click)="clearSearch()" />
                }
            </p-iconfield>
            }
            @for (filter of columns; track filter.header) {
            @if (filter.filterType === 'select') {
            <p-select class="multi-select" appendTo="body" [options]="filter.filterOptions" [formControl]="filterControls[filter.field]"
                optionLabel="label" optionValue="value" placeholder="{{ filter.header }}" showClear="true"
                [filter]="true" (onChange)="onDropdownChange($event.value)">
            </p-select>
            }
            @else if (filter.filterType === 'multiselect') {
            <p-multiSelect class="multi-select" appendTo="body" [options]="filter.filterOptions"
                [formControl]="filterControls[filter.field]" optionLabel="label" optionValue="value"
                placeholder="{{ filter.header }}" selectedItemsLabel="{0} selected">
            </p-multiSelect>
            }
            }
            @for (filter of customFilters; track filter.key) {
            @if (filter.type === 'date-range') {
            <p-datepicker appendTo="body" selectionMode="range" [formControl]="customFilterControls[filter.key]"
                placeholder="{{ filter.label }}"></p-datepicker>
            }
            @else if (filter.type === 'select') {
            <p-select class="multi-select" appendTo="body" [options]="filter.options" [formControl]="customFilterControls[filter.key]"
                optionLabel="label" optionValue="value" placeholder="{{ filter.shortLabel || filter.label }}" [showClear]="filter.clearable !== false"
                [filter]="true" (onChange)="onDropdownChange($event.value)">
            </p-select>
            }
            @else if (filter.type === 'multiselect') {
            <p-multiSelect class="multi-select" appendTo="body" [options]="filter.options" [formControl]="customFilterControls[filter.key]"
                optionLabel="label" optionValue="value" [placeholder]="filter.shortLabel || filter.label"
                [filter]="true" [showClear]="true" selectedItemsLabel="{0} selected"
                (onChange)="onDropdownChange($event.value)">
            </p-multiSelect>
            }
            }
            @if (showClearFilters && !hasSliderFilters) {
            <p-button text="true" [disabled]="!hasActiveFilters" (onClick)="clearAllFilters()">
                <ng-template #icon>
                    <img src="assets/icons/circular-counterclockwise-arrow-rotation_60585 1.svg" alt="Send" />
                </ng-template>
            </p-button>
            }
        </div>
    </div>
    } @else {
    <!-- ── Compact layout: row 1 = search + view toggle, row 2 = filters ── -->
    <div class="compact-filter-bar">
        <!-- Row 1: search + header actions -->
        <div class="compact-row-top">
            @if (showSearch) {
            <p-iconfield class="search-compact">
                <p-inputicon><img src="assets/icons/search.svg" alt="search icon" /></p-inputicon>
                <input type="text" pInputText [placeholder]="searchPlaceholder || 'Search'" class="w-full search-bar"
                    [formControl]="searchControl" />
                @if (searchControl.value) {
                <p-inputicon class="fa-solid fa-xmark cursor-pointer text-500" (click)="clearSearch()" />
                }
            </p-iconfield>
            }
            @if (headerActions) {
            <ng-container [ngTemplateOutlet]="headerActions"></ng-container>
            }
        </div>
        <!-- Row 2: chip filters + select filters -->
        <div class="compact-row-filters">
            <button class="chip-filter" [class.chip-filter--active]="!hasActiveFilters" (click)="clearAllFilters()">All</button>
            @for (filter of customFilters; track filter.key) {
            @if (filter.type === 'chip') {
            @for (opt of filter.options; track opt.label) {
            <button class="chip-filter"
                [class.chip-filter--active]="customFilterControls[filter.key].value === opt.value"
                (click)="setChipFilter(filter.key, opt.value, !!opt.clearsOthers)">
                {{ opt.label }}
            </button>
            }
            }
            }
            @for (filter of columns; track filter.header) {
            @if (filter.filterType === 'select') {
            <p-select class="multi-select filter-select" appendTo="body" [options]="filter.filterOptions"
                [formControl]="filterControls[filter.field]" optionLabel="label" optionValue="value"
                placeholder="{{ filter.header }}" showClear="true" [filter]="true"
                (onChange)="onDropdownChange($event.value)">
            </p-select>
            }
            @else if (filter.filterType === 'multiselect') {
            <p-multiSelect class="multi-select filter-select" appendTo="body" [options]="filter.filterOptions"
                [formControl]="filterControls[filter.field]" optionLabel="label" optionValue="value" display="chip"
                placeholder="{{ filter.header }}">
            </p-multiSelect>
            }
            }
            @for (filter of customFilters; track filter.key) {
            @if (filter.type === 'date-range') {
            <p-datepicker appendTo="body" selectionMode="range" [formControl]="customFilterControls[filter.key]"
                placeholder="{{ filter.label }}"></p-datepicker>
            }
            @else if (filter.type === 'select') {
            <p-select class="multi-select filter-select" appendTo="body" [options]="filter.options"
                [formControl]="customFilterControls[filter.key]" optionLabel="label" optionValue="value"
                placeholder="{{ filter.label }}" [showClear]="filter.clearable !== false" [filter]="true"
                (onChange)="onDropdownChange($event.value)">
            </p-select>
            }
            @else if (filter.type === 'multiselect' || filter.type === 'multiselect-param') {
            <p-multiSelect class="multi-select filter-select" appendTo="body" [options]="filter.options"
                [formControl]="customFilterControls[filter.key]" optionLabel="label" optionValue="value"
                [placeholder]="filter.label" [filter]="true" [showClear]="true"
                [selectedItemsLabel]="($any(customFilterControls[filter.key].value)?.length || 0) + ' selected'"
                (onChange)="onDropdownChange($event.value)">
            </p-multiSelect>
            }
            }
            @if (showClearFilters && !hasSliderFilters) {
            <p-button text="true" [disabled]="!hasActiveFilters" (onClick)="clearAllFilters()">
                <ng-template #icon>
                    <img src="assets/icons/circular-counterclockwise-arrow-rotation_60585 1.svg" alt="Send" />
                </ng-template>
            </p-button>
            }
        </div>
    </div>
    }

</div>

<ng-content></ng-content>

@if (showTable) {
    <p-table [value]="data" [columns]="visibleColumns" (sortFunction)="onSort($event)" [customSort]="true">
        <!-- Header -->
        <ng-template #header let-columns>
            <tr>
                @for (col of columns; track col.header) {
                <th [pSortableColumn]="col.sortable ? col.field : null" class="cursor-pointer">
                    <div class="t-head flex flex-row gap-2">
                        {{ col.header }}
                        @if (col.sortable) {
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                        }
                    </div>
                </th>
                }
            </tr>
        </ng-template>

        <!-- Body -->
        <ng-template #body let-row let-index="rowIndex" let-columns="columns">
            <tr (click)="onRowClick($event, row)" (mouseup)="onRowMouseUp($event, row)" (auxclick)="onRowAuxClick($event, row)" [class.cursor-pointer]="!!rowCommand || !!rowLink">
                @for (col of columns; track col.header) {
                <td class="t-body"
                    [ngClass]="typeof col.cellClass === 'string' ? col.cellClass : col.cellClass?.(row[col.field], row)">
                    @if (col.isRowIndex) {
                    <span class="t-body row-index-cell">{{ first + index + 1 }}</span>
                    }
                    @else if (col.isCarImage) {
                    <img [src]="row[col.field]" alt="car" class="car-thumb-img"
                        (error)="$any($event.target).src='assets/icons/car-placeholder.svg'" />
                    }
                    @else if (col.thumbnailField) {
                    <div class="flex align-items-center gap-2" role="button" tabindex="0" (click)="onThumbnailClick($event, col, row)" (keydown.enter)="col.command?.(row, $event)">
                        <img [src]="row[col.thumbnailField]" alt="car" class="car-thumb-img"
                            (error)="$any($event.target).src='assets/icons/car-placeholder.svg'" />
                        <span [ngClass]="typeof col.cellClass === 'string' ? col.cellClass : col.cellClass?.(row[col.field], row)">{{ renderCellValue(row, col) }}</span>
                    </div>
                    }
                    @else if (col.isPlateCell) {
                    <div class="flex align-items-center gap-2">
                        <img [src]="row['imageUrl']" alt="car" class="plate-img"
                            (error)="$any($event.target).src='assets/icons/car-placeholder.svg'" />
                        <div class="flex flex-column gap-1">
                            <span class="font-medium">{{ row['plateNo'] }}</span>
                            <span class="text-sm plate-id">#{{ row['id'] }}</span>
                        </div>
                    </div>
                    }
                    @else if (col.locationCell) {
                    <div class="flex align-items-center justify-content-center gap-2">
                        @if (renderCellValue(row, col) !== '---') {
                        <span>{{ renderCellValue(row, col) }}</span>
                        }
                        @if (col.command) {
                        <button class="location-btn" (click)="col.command(row, $event); $event.stopPropagation()">
                            <img src="assets/icons/location-arrow.svg" alt="location" />
                        </button>
                        }
                    </div>
                    }
                    @else if (col.isProgressBar) {
                    <div class="progress-wrap">
                        <div class="progress-track">
                            <div class="progress-fill" [style.width.%]="getProgressValue(row, col)"
                                [style.background]="col.progressColorGetter ? col.progressColorGetter(getProgressValue(row, col), row) : '#3b82f6'">
                            </div>
                        </div>
                        <span class="progress-label">{{ getProgressValue(row, col) }}%</span>
                    </div>
                    }
                    @else if (col.isStatusBadge) {
                    @if (row[col.field]) {
                    <button type="button" class="status-badge"
                        [style.background]="col.badgeStyleGetter ? col.badgeStyleGetter(row[col.field], row).background : 'transparent'"
                        [style.color]="col.badgeStyleGetter ? col.badgeStyleGetter(row[col.field], row).color : 'inherit'"
                        (click)="col.command?.(row); $event.stopPropagation()">
                        <span class="status-dot"
                            [style.background]="col.badgeStyleGetter ? col.badgeStyleGetter(row[col.field], row).color : 'currentColor'">
                        </span>
                        <span>{{ renderCellValue(row, col) }}</span>
                        @if (col.command) {
                        <i class="fa-solid fa-chevron-down" style="font-size: 8px; margin-left: 2px; opacity: 0.6;"></i>
                        }
                    </button>
                    } @else {
                    <span>---</span>
                    }
                    }
                    @else if (col.actions) {
                    <div class="flex align-items-center justify-center gap-1">
                        @for (action of col.actions; track action.icon) {
                        @if (
                        action.visible === undefined ||
                        action.visible === true ||
                        (typeof action.visible === 'function' && action.visible(row))
                        ) {
                        @if (action.isTextButton) {
                        <button type="button" class="action-text-btn" (click)="action.command?.(row); $event.stopPropagation()">
                            {{ action.text }}
                        </button>
                        }

                        <!-- 📍 Location Button -->
                        @else if (action.isLocationButton) {
                        <button class="location-btn" (click)="action.command?.(row, $event); $event.stopPropagation()"
                            [pTooltip]="action.tooltip" tooltipPosition="top" tooltipStyleClass="tooltip">
                            <img src="assets/icons/location-arrow.svg" alt="location" />
                        </button>
                        }

                        <!-- ✅ Icon Button -->
                        @else {
                        <p-button [styleClass]="'p-button-text button-icon ' + (action.buttonClass ?? '')"
                            (click)="action.command?.(row)" [pTooltip]="action.tooltip" tooltipPosition="top"
                            tooltipStyleClass="tooltip" size="small">
                            <ng-template pTemplate="content">
                                @if (action.icon && action.icon.endsWith('.svg')) {
                                <img [src]="'assets/icons/' + action.icon" [ngClass]="action.color" alt="action icon" class="action-btn-icon" />
                                } @else if (action.icon) {
                                <i [class]="action.icon" [ngClass]="action.color"></i>
                                }
                                @if (action.badgeGetter && action.badgeGetter(row) !== null && action.badgeGetter(row) !== undefined) {
                                <span class="action-btn-badge">{{ action.badgeGetter(row) }}</span>
                                }
                            </ng-template>
                        </p-button>
                        }
                        }
                        }
                    </div>
                    }
                    @else if (col.isAvatar) {
                    <div class="avatar-cell">
                        @if (col.avatarImageField && row[col.avatarImageField]) {
                        <img class="avatar-img" [src]="row[col.avatarImageField]" [alt]="row[col.field] + ''"
                            (error)="$any($event.target).style.display='none'; $any($event.target).nextElementSibling.style.display='flex'" />
                        <div class="avatar-circle" [style.display]="'none'" [style.background]="getAvatarColor((row[col.field] ?? '') + ' ' + (col.mergedName ? (row[col.mergedName] ?? '') : ''))">
                            {{ getAvatarInitials(row[col.field] + '', col.mergedName ? row[col.mergedName] + '' : '') }}
                        </div>
                        } @else {
                        <div class="avatar-circle" [style.background]="getAvatarColor((row[col.field] ?? '') + ' ' + (col.mergedName ? (row[col.mergedName] ?? '') : ''))">
                            {{ getAvatarInitials(row[col.field] + '', col.mergedName ? row[col.mergedName] + '' : '') }}
                        </div>
                        }
                        <div class="avatar-info">
                            <span class="avatar-name">{{ row[col.field] }} {{ col.mergedName ? row[col.mergedName] : '' }}</span>
                            @if (col.bottomField) {
                            <span class="avatar-sub"
                                [class.avatar-sub--link]="!!col.bottomFieldCommand"
                                [attr.tabindex]="col.bottomFieldCommand ? 0 : null"
                                [attr.role]="col.bottomFieldCommand ? 'button' : null"
                                (click)="onBottomFieldClick($event, col, row)"
                                (keydown.enter)="onBottomFieldClick($event, col, row)">
                                {{ getNestedValue(row, col.bottomField) || '' }}
                            </span>
                            }
                        </div>
                    </div>
                    }
                    @else {
                    @if ((col.routerLink || col.command) && (col.commandEnabled ? col.commandEnabled(row) : true)) {
                    <a class="cursor-pointer no-underline cell-command-link" [routerLink]="col.routerLink"
                        [ngClass]="typeof col.cellClass === 'string' ? col.cellClass : col.cellClass?.(row[col.field], row)"
                        (click)="col.command?.(row, $event)">
                        <span class="flex align-items-center gap-2"
                            [class.justify-content-center]="col.cellClass === 'text-center'">

                            <!-- 🧭 ICON LEFT -->
                            @if (col.icon && col.iconPosition === 'left') {
                            <i [class]="col.icon"></i>
                            }

                            <!-- 🧩 PREFIX (only when no bottomField; otherwise inlined below) -->
                            @if (col.prefixText && !col.bottomField) {
                            <span>{{ col.prefixText }}</span>
                            }

                            <!-- 🧠 MAIN VALUE -->
                            <ng-container>

                                @if (col.isBoolean) {
                                <span [ngClass]="row[col.field] ? 'tc-status-badge tc-status-badge--active' : 'tc-status-badge tc-status-badge--inactive'">
                                    <span class="tc-status-dot"></span>
                                    {{ row[col.field] ? col.trueLabel : col.falseLabel }}
                                </span>
                                }
                                @else if (col.isDuration) {
                                @if (row[col.field]) {
                                <span>{{ row[col.field] | duration: (col.durationFormat ?? 'hms') }}</span>
                                }@else {
                                <span>---</span>
                                }
                                }
                                @else if (col.isTime) {
                                <span [attr.title]="row[col.field] | date: 'dd-MM-yyyy hh:mm:ss'">{{ row[col.field] ? ($any(row[col.field]) | date:'hh:mm a') : '---' }}</span>
                                }
                                @else if (col.isCurrency) {
                                <span>{{ row[col.field] !== null && row[col.field] !== undefined ? ('AED ' + row[col.field]) : '---' }}</span>
                                }
                                @else if (col.isDateTime) {
                                @if (row[col.field]) {
                                <div class="flex flex-column w-6rem">
                                    <span class="font-medium">{{ row[col.field] | date:'dd-MM-yyyy' }}</span>
                                    <span class="text-500 date">{{ row[col.field] | date:'hh:mm:ss a' }}</span>
                                </div>
                                }@else {
                                <span>---</span>
                                }
                                }
                                @else if (col.isBrowserTime) {
                                @if (row[col.field]) {
                                <div class="flex flex-column w-6rem">

                                    <span class="font-medium">
                                        {{ (row[col.field] + 'Z') | date:'dd-MM-yyyy' }}
                                    </span>

                                    <span class="text-500 date">
                                        {{ (row[col.field] + 'Z') | date:'hh:mm:ss a' }}
                                    </span>

                                </div>
                                } @else {
                                <span>---</span>
                                }
                                }
                                @else if (col.isDate) {
                                @if (row[col.field]) {
                                <span>{{ row[col.field] | date:'mediumDate' }}</span>
                                }@else {
                                <span>---</span>
                                }
                                }
                                @else if (col.bottomField) {
                                <div class="flex flex-column gap-1">

                                    <span class="cell-main-value">{{ (col.prefixText || '') + renderCellValue(row, col) }}{{ col.mergedName ? ' ' + getNestedValue(row, col.mergedName) : '' }}</span>

                                    <span class="cell-sub-value"
                                        [class.cell-sub-value--link]="!!col.bottomFieldCommand"
                                        [attr.tabindex]="col.bottomFieldCommand ? 0 : null"
                                        [attr.role]="col.bottomFieldCommand ? 'button' : null"
                                        (click)="onBottomFieldClick($event, col, row)"
                                        (keydown.enter)="onBottomFieldClick($event, col, row)">
                                        @if (col.isBottomFieldDate) {
                                        {{ ($any(getNestedValue(row, col.bottomField)) | date:'d MMM') || '---' }}
                                        } @else {
                                        {{ getNestedValue(row, col.bottomField) || '---' }}
                                        }
                                    </span>

                                </div>
                                }
                                @else if (col.mergedName) {
                                <span>{{ renderCellValue(row, col) }} {{ getNestedValue(row, col.mergedName) }}</span>
                                }
                                @else if (col.isCapitalize) {
                                <span>{{ renderCellValue(row, col) | capitalize }}</span>
                                }
                                @else if (col.isRating) {
                                @if (row[col.field]) {
                                <p-rating [ngModel]="row[col.field]" [readonly]="true" [stars]="5"></p-rating>
                                } @else {
                                ---
                                }
                                }
                                @else {
                                <span>{{ renderCellValue(row, col) }}</span>
                                }
                            </ng-container>

                            <!-- 📋 COPY -->
                            @if (col.isCopy) {
                            <button class="copy-btn" [class.copy-btn--copied]="isCopied(index, col.field + '')" type="button" (click)="copyToClipboard($event, row[col.field], index, col.field + '')" title="Copy">
                                <i [class]="isCopied(index, col.field + '') ? 'fa-solid fa-check' : 'fa-regular fa-copy'"></i>
                            </button>
                            }

                            <!-- 🧩 SUFFIX -->
                            @if (col.suffixText) {
                            <span>{{ col.suffixText }}</span>
                            }

                            <!-- 🧭 ICON RIGHT -->
                            @if (col.icon && col.iconPosition === 'right') {
                            <i [class]="col.icon"></i>
                            }

                        </span>
                    </a>
                    }
                    @else {
                    <span class="flex align-items-center gap-2"
                        [class.justify-content-center]="col.cellClass === 'text-center'">

                        <!-- 🧭 ICON LEFT -->
                        @if (col.icon && col.iconPosition === 'left') {
                        <i [class]="col.icon"></i>
                        }

                        <!-- 🧩 PREFIX (only when no bottomField; otherwise inlined below) -->
                        @if (col.prefixText && !col.bottomField) {
                        <span>{{ col.prefixText }}</span>
                        }

                        <!-- 🧠 MAIN VALUE -->
                        <ng-container>
                            @if (col.isBoolean) {
                            <span [ngClass]="row[col.field] ? 'tc-status-badge tc-status-badge--active' : 'tc-status-badge tc-status-badge--inactive'">
                                <span class="tc-status-dot"></span>
                                {{ row[col.field] ? col.trueLabel : col.falseLabel }}
                            </span>
                            }
                            @else if (col.isDuration) {
                            @if (row[col.field]) {
                            <span>{{ row[col.field] | duration: (col.durationFormat ?? 'hms') }}</span>
                            }@else {
                            <span>---</span>
                            }
                            }
                            @else if (col.isTime) {
                            <span [attr.title]="row[col.field] | date: 'dd-MM-yyyy hh:mm:ss a'">{{ row[col.field] ? ($any(row[col.field]) | date:'hh:mm a') : '---' }}</span>
                            }
                            @else if (col.isCurrency) {
                            <span>{{ row[col.field] !== null && row[col.field] !== undefined ? ('AED ' + row[col.field]) : '---' }}</span>
                            }
                            @else if (col.isDateTime) {
                            @if (row[col.field]) {
                            <div class="flex flex-column w-6rem">
                                <span class="font-medium">{{ row[col.field] | date:'dd-MM-yyyy' }}</span>
                                <span class="text-500 date">{{ row[col.field] | date:'hh:mm:ss a' }}</span>
                            </div>
                            }@else {
                            <span>---</span>
                            }
                            }
                            @else if (col.isBrowserTime) {
                            @if (row[col.field]) {
                            <div class="flex flex-column w-6rem">

                                <span class="font-medium">
                                    {{ (row[col.field] + 'Z') | date:'dd-MM-yyyy' }}
                                </span>

                                <span class="text-500 date">
                                    {{ (row[col.field] + 'Z') | date:'hh:mm:ss a' }}
                                </span>

                            </div>
                            } @else {
                            <span>---</span>
                            }
                            }
                            @else if (col.isDate) {
                            @if (row[col.field]) {
                            <span>{{ row[col.field] | date:'mediumDate' }}</span>
                            }@else {
                            <span>---</span>
                            }
                            }

                            @else if (col.bottomField) {
                            <div class="flex flex-column gap-1">

                                <span class="cell-main-value">
                                    @if (col.prefixText) { {{ col.prefixText }} }{{ renderCellValue(row, col) }}{{ col.mergedName ? ' ' + getNestedValue(row, col.mergedName) : '' }}
                                </span>

                                <span class="cell-sub-value"
                                    [class.cell-sub-value--link]="!!col.bottomFieldCommand"
                                    [attr.tabindex]="col.bottomFieldCommand ? 0 : null"
                                    [attr.role]="col.bottomFieldCommand ? 'button' : null"
                                    (click)="onBottomFieldClick($event, col, row)"
                                    (keydown.enter)="onBottomFieldClick($event, col, row)">
                                    @if (col.isBottomFieldDate) {
                                    {{ ($any(getNestedValue(row, col.bottomField)) | date:'d MMM') || '---' }}
                                    } @else {
                                    {{ getNestedValue(row, col.bottomField) || '---' }}
                                    }
                                </span>

                            </div>
                            } @else if (col.mergedName) {
                            <span>{{ renderCellValue(row, col) }} {{ getNestedValue(row, col.mergedName) }}</span>
                            }
                            @else if (col.isCapitalize) {
                            <span>{{ renderCellValue(row, col) | capitalize }}</span>
                            }
                            @else if (col.isRating) {
                            @if (row[col.field]) {
                            <p-rating [ngModel]="row[col.field]" [readonly]="true" [stars]="5"></p-rating>
                            } @else {
                            ---
                            }
                            <!-- <p-rating [ngModel]="row[col.field]" [readonly]="true">
                                </p-rating> -->
                            }
                            @else {
                            <span>{{ renderCellValue(row, col)}}</span>
                            }
                        </ng-container>

                        <!-- 📋 COPY -->
                        @if (col.isCopy) {
                        <button class="copy-btn" [class.copy-btn--copied]="isCopied(index, col.field + '')" type="button" (click)="copyToClipboard($event, row[col.field], index, col.field + '')" title="Copy">
                            <i [class]="isCopied(index, col.field + '') ? 'fa-solid fa-check' : 'fa-regular fa-copy'"></i>
                        </button>
                        }

                        <!-- 🧩 SUFFIX -->
                        @if (col.suffixText) {
                        <span>{{ col.suffixText }}</span>
                        }

                        <!-- 🧭 ICON RIGHT -->
                        @if (col.icon && col.iconPosition === 'right') {
                        <i [class]="col.icon"></i>
                        }

                    </span>
                    }
                    }
                </td>
                }
            </tr>
        </ng-template>

        <!-- Empty message -->
        <ng-template #emptymessage>
            <tr>
                <td [colSpan]="columns.length + 1" class="text-center font-semibold">
                    No data
                </td>
            </tr>
        </ng-template>

    </p-table>

    @if (data.length > 0) {
    <div class="table-footer">
        <span class="footer-count">Showing {{ first + data.length }} of {{ totalRecords }}</span>
        <p-paginator [first]="first" [rows]="rows" [totalRecords]="totalRecords" [rowsPerPageOptions]="[20, 30, 50, 100]"
            [dropdownAppendTo]="'body'" (onPageChange)="onPageChange($event)" />
    </div>
    }
}